export default "__VITE_ASSET__ChygDUTg__"